import {SceneInjectionChain} from "../gameobjects/SceneInjectionChain";
import {SceneInjectionCharacterReaction} from "../gameobjects/SceneInjectionCharacterReaction";
import {ZoraHurstonCutouts} from "../layout/ZoraHurstonCutouts";
import {ZoraHurstonStoryLayout_scene1Start, ZoraHurstonStoryLayout_scene2Encounter, ZoraHurstonStoryLayout_scene4Help, ZoraHurstonStoryLayout_scene5Result, ZoraHurstonStoryLayout_scene6End} from "../layout/ZoraHurstonStoryLayout";
import {BookId} from "./BookId";
import {CharacterType} from "./CharacterType";
import {CutoutData} from "./CutoutData";
import {StoryModel} from "./StoryModel";

export const StoryZoraHurston: StoryModel<ZoraHurstonSceneId, ZoraHurstonSlotId> = {
    storyId: BookId.Hurston,
    storyIndex: 4,
    promptVO: "hur_xavier_st_{index}",
    optionVO: "hur_xavier_st_{index}",
    optionIcon: "hur-{option}-buttonimg",
    introVO: ["hur_yadina_in_001", "hur_brad_in_001", "hur_xavier_in_001"],
    outroVO: ["hur_brad_out_001", "hur_xavier_out_001", "hur_yadina_out_001"],
    outroImage: "hur-story-image",
    cutouts: new CutoutData(ZoraHurstonCutouts),
    scenes: [
        {
            sceneId: "start",
            sfx: "sc_002_XR103A_003_ Rising String Notes",
            cc: "Brad was writing his new comic book alone in {option-start.}",
            voIndex: 1,
            options: [
                {optionId: "classroom", cc: "The classroom", voIndex: 2},
                {optionId: "playground", cc: "The playground", iconPosition: {x: 0, y: -30}, voIndex: 3},
                {optionId: "kidzone", cc: "The art room", voIndex: 4},
                {optionId: "dinosaur", cc: "The museum", voIndex: 5},
            ],
            layout: ZoraHurstonStoryLayout_scene1Start,
        },
        {
            sceneId: "encounter",
            sfx: {"sc_046_XR111B_094_DUn Dun Dun Music": 0, "sc_054_XR102A_018_Thud Bodyfall": 0.2},
            cc: "When suddenly, Brad saw a lonely {option-encounter!}",
            voIndex: 6,
            options: [
                {optionId: "marshmallow", cc: "Marshmallow", voIndex: 7},
                {optionId: "moose", cc: "Moose", voIndex: 8},
                {optionId: "octopus", cc: "Octopus", voIndex: 9},
                {optionId: "mummy", cc: "Mummy", voIndex: 10},
            ],
            layout: ZoraHurstonStoryLayout_scene2Encounter,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Yadina, "re_yadina_005"),
            },
        },
        // {
        //     sceneId: "reaction",
        //     cc: "When Brad saw it, he felt {option-reaction.}",
        //     options: [
        //         {optionId: "sad", cc: "Sad", icon: "hur-b-sad-buttonimg", sfx: "sc_072_XRMovie_695_Dun Dun Dun Strings"},
        //         {optionId: "nervous", cc: "Nervous", icon: "hur-b-nervous-buttonimg", sfx: "sc_032_XR111B_081_Short Nervous Brad Cue"},
        //         {optionId: "brave", cc: "Brave", icon: "hur-b-brave-buttonimg", sfx: "sc_042_XR102A_080_Triumphant Orchestra"},
        //     ],
        //     layout: ZoraHurstonStoryLayout_scene3Reaction,
        // },
        {
            sceneId: "help",
            sfx: "sc_015_XE111B_001_Music (Gameshowy)",
            cc: "So, Brad decided to share his comic book about {option-help!}",
            voIndex: 11,
            options: [
                {optionId: "bikeman", cc: "Bike Man", icon: "hur-story-bikeman-buttonimg", voIndex: 12},
                {optionId: "agent", cc: "Agent Chaos", icon: "hur-story-agentchaos-buttonimg", voIndex: 13},
                {optionId: "cape", cc: "Baby Brad", icon: "hur-story-cape-buttonimg", voIndex: 14},
            ],
            layout: ZoraHurstonStoryLayout_scene4Help,
        },
        {
            sceneId: "result",
            cc: "Reading Brad's comic book together made it so {option-result.}",
            voIndex: 15,
            options: [
                {optionId: "happy", cc: "Happy", icon: "hur-emoji-happy", iconPosition: "center", voIndex: 16, sfx: "sc_015_XE111B_001_Music (Gameshowy)"},
                {optionId: "silly", cc: "Silly", icon: "hur-emoji-silly", iconPosition: "center", optionVO: "hur_xavier_st_017_alt", sfx: "sc_056_XR113B_099_Flat Bass-y Horns"},
                {optionId: "hungry", cc: "Hungry", icon: "hur-emoji-hungry", iconPosition: "center", voIndex: 18, sfx: "sc_085_hungry"},
            ],
            layout: ZoraHurstonStoryLayout_scene5Result,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Yadina, "re_yadina_006"),
            },
        },
        {
            sceneId: "end",
            cc: "So then, they decided to {option-end!}",
            voIndex: 19,
            options: [
                {
                    optionId: "jam", cc: "Make Strawberry Jam", iconPosition: "center", voIndex: 20,
                    sfx: {"sc_039_102A_072_Upward Chimes": 0, "sc_019_XR111B_131_Whoosh": 0, "sc_049_XR111B_002_Heavy Book Impact": 0.4},
                },
                {optionId: "newstory", cc: "Write a New Story", iconPosition: "center", sfx: "sc_013_XR102A_050_Paper Rustling", voIndex: 21},
                {
                    optionId: "icecream", cc: "Eat Ice Cream", iconPosition: "center", voIndex: 22,
                    sfx: {"sc_039_102A_072_Upward Chimes": 0, "sc_019_XR111B_131_Whoosh": 0, "sc_049_XR111B_002_Heavy Book Impact": 0.4},
                },
                {optionId: "danceparty", cc: "Have a Dance Party", iconPosition: "center", sfx: "sc_061_XR116B_064_Big Band Jazz", optionVO: "hur_xavier_st_023_alt2"},
            ],
            layout: ZoraHurstonStoryLayout_scene6End,
            injections: {
                afterFullVO: new SceneInjectionChain(
                    new SceneInjectionCharacterReaction(CharacterType.Brad, "re_brad_005", true),
                    new SceneInjectionCharacterReaction(CharacterType.Xavier, "hur_xavier_st_024"),
                ),
            },
        },
    ],
};

export type ZoraHurstonSceneId =
    "start"
    | "encounter"
    | "reaction"
    | "help"
    | "result"
    | "end";
export type ZoraHurstonSlotId = ZoraHurstonSceneId;
